import { render, staticRenderFns } from "./FeeItemsSection.vue?vue&type=template&id=e28dcd7c&scoped=true"
import script from "./FeeItemsSection.vue?vue&type=script&lang=js"
export * from "./FeeItemsSection.vue?vue&type=script&lang=js"
import style0 from "./FeeItemsSection.vue?vue&type=style&index=0&id=e28dcd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28dcd7c",
  null
  
)

export default component.exports